// Selector de idioma (la de siempre: components/LanguageSelector). Mismos idiomas y misma preferencia
// (`app_language`, src/i18n). Menú del sistema: teclado completo, Esc cierra, el activo va marcado.
import { Globe } from 'lucide-react';
import { Menu } from '../../ds/components/overlays/Menu';
import { Button } from '../../ds/components/core/Button';
import { useLanguage } from '../../i18n';

const IDIOMAS = [
  { code: 'en', nombre: 'English' },
  { code: 'es', nombre: 'Español' },
  { code: 'pt', nombre: 'Português' },
];

export default function SelectorIdioma() {
  const { language, setLanguage, t } = useLanguage();
  const actual = IDIOMAS.find((i) => i.code === language) ?? IDIOMAS[0];
  const items = IDIOMAS.map((i) => ({
    id: i.code,
    label: i.nombre,
    meta: i.code.toUpperCase(),
    checked: i.code === language,
    onSelect: () => setLanguage(i.code),
  }));
  return (
    <Menu
      label={t('language')}
      placement="bottom-end"
      minWidth={200}
      items={items}
      trigger={(
        <Button variant="ghost" size="sm" icon={Globe} aria-label={`${t('language')}: ${actual.nombre} (${actual.code.toUpperCase()})`}>
          <span aria-hidden="true">{actual.code.toUpperCase()}</span>
        </Button>
      )}
    />
  );
}
